/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Element } from './element';


export interface ApplicationCustomType { 
    any?: Array<Element>;
    otherAttributes?: { [key: string]: string; };
}

